import React from "react";
import { connect } from "react-redux";

import Polls from "../components/polls";
import { fetch, save } from "../actions/pollActions";

const PollsContainer = (props) => {
  return <Polls {...props} />;
};

const mapStateToProps = (state, props) => {
  return {
    envContext: state.envContext?.data ?? {},
    polls: state?.polls?.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  save: (pollsData, navigate, setLoading) => {
    dispatch(save(pollsData, navigate, setLoading));
  },
  fetch: () => {
    dispatch(fetch());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PollsContainer);
